module.exports = __webpack_public_path__ + "img/VP7000-image.06267c15.jpeg";